module.exports = __webpack_public_path__ + "static/media/spinman-peace.06b45c4a.png";